export class NumberUtils {
  private static MAX_DECIMAL_PLACES = 6
  static format(
    numberValue: number,
    locale: string,
    options = {},
    roundLongNumber = false,
    roundBillions = true,
  ): string {
    const absoluteNumber = Math.abs(numberValue)
    if (roundLongNumber) {
      if (roundBillions && absoluteNumber >= 1.0e9) {
        return `${(numberValue / 1.0e9).toLocaleString(locale, options)}B`
      }
      if (absoluteNumber >= 1.0e6) {
        return `${(numberValue / 1.0e6).toLocaleString(locale, options)}M`
      }
    }
    return numberValue.toLocaleString(locale, options)
  }

  static truncNumberWithoutRounding(value: number): number {
    return Math.trunc(value * 10 ** this.MAX_DECIMAL_PLACES) / 10 ** this.MAX_DECIMAL_PLACES
  }

  static round(value: number, decimals = 0): number {
    const factor = 10 ** decimals
    return Math.round(value * factor) / factor
  }
}
